<template>
  <section class="v-gradient-bg v-gradient-bg--fixed v-gradient-bg--gold py-16">
    <div class="container mx-auto v-page-section-container-padding _custom-carousel-padding">
      <div class="md:grid grid-cols-1 md:grid-cols-12">
        <AtomHeadingPageSection
          class="md:col-span-10 md:col-start-2 lg:col-start-1 2xl:col-start-2 mb-5"
          text-color="text-app-primary-1-red--fire-brick"
          :title="$t('discover-more')"
        />
      </div>
      <div class="hidden md:grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-8">
        <div v-for="(item, index) in entries" :key="index" class="md:col-span-10 md:col-start-2 lg:col-span-6 2xl:col-span-5 2xl:odd:col-start-2">
          <MoleculeCardDiscoverLandscape :image="item.teaserImage" :category="item.category" :title="item.title" :url="item.url" />
        </div>
      </div>
      <div class="md:hidden">
        <MoleculeCarousel :entries="entries" :breakpoints="breakpoints" :gap="16">
          <template #slide="{ slide }">
            <MoleculeCardDiscoverPortrait :image="slide.teaserImage" :category="slide.category" :title="slide.title" :url="slide.url" />
          </template>
        </MoleculeCarousel>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  entries: { type: Array as PropType<any[]>, required: true },
})

// Swiper's breakpoints are keyed by min-width ("at this width and up"), unlike Glide's max-width keys
// used before the Swiper migration; `peek.after` (px) becomes `slidesOffsetAfter` (px).
const breakpoints = computed(() => {
  return {
    0: { slidesPerView: 1, slidesOffsetAfter: 120 },
    540: { slidesPerView: 2, slidesOffsetAfter: 120 },
    640: { slidesPerView: 2, slidesOffsetAfter: 0 },
  }
})
</script>

<style scoped lang="scss">
// same values as in .page-section-container-padding-wide-screens
._custom-carousel-padding {
  @apply pr-0; // except on xs screens

  @screen sm {
    @apply pr-6;
  }

  @screen md {
    @apply pr-5;
  }

  @screen lg {
    @apply pr-10;
  }

  @screen xl {
    @apply pr-16;
  }

  @screen 2xl {
    @apply pr-32;
  }
}
</style>
